import { ReactNode } from "react";
import AppShell, { PageHeader } from "./shell/app-shell";

type Props = {
  pageTitle: string;
  subtitle?: string;
  children: ReactNode;
  primaryAction?: ReactNode;
};

export default function PageLayout({ pageTitle, subtitle, children, primaryAction }: Props) {
  return (
    <AppShell>
      <PageHeader title={pageTitle} subtitle={subtitle} actions={primaryAction} />
      <div className="min-w-0 max-w-full">{children}</div>
    </AppShell>
  );
}
